// REACT
import React from "react";

// GRID
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";

// IMAGES
import NetWork from "../../assets/images/Icons Network/ic-badge-big.svg";

export default class Banner extends React.Component {
  renderTime(times) {
    const t = this.props.t;
    if (times.length > 0) {
      if (
        times[0].days !== "" &&
        times[0].open !== "" &&
        times[0].close !== ""
      ) {
        let timeFormat = [];
        let allDays = [];
        // SORT AND INT
        times.forEach((time) => {
          let daysOrder = [];

          time.days.forEach((day) => {
            daysOrder.push(Number(day));
            allDays.push(Number(day));
          });

          timeFormat.push({
            open: time.open,
            close: time.close,
            days: daysOrder.sort(),
          });
        });

        let timeToRender = [];

        const daysText = [
          t("Domingo"),
          t("Segunda"),
          t("Terça"),
          t("Quarta"),
          t("Quinta"),
          t("Sexta"),
          t("Sábado"),
          t("Feriados"),
        ];

        timeFormat.forEach((time, index) => {
          if (time.days.length > 1) {
            let number1;
            let number2;
            let daysString;
            let sequence = [];

            for (let i = 0; i <= time.days.length - 1; i++) {
              number1 = Number(time.days[i]);
              number2 = Number(time.days[i - 1]);

              if (number1 === 0) {
                number1 = 1;
                number2 = 1 - 1;
              }

              let total = number1 - number2;

              if (total !== 1) {
                sequence.push(false);
              } else {
                sequence.push(true);
              }
            }

            let findFalse = sequence.indexOf(false);

            if (findFalse === -1) {
              timeToRender.push({
                days:
                  daysText[time.days[0]] +
                  " " +
                  t("a") +
                  " " +
                  daysText[time.days[time.days.length - 1]],
                open: time.open,
                close: time.close,
              });
            } else {
              time.days.forEach((value, index) => {
                if (index === 0) {
                  daysString = daysText[value];
                } else if (index === value.length - 1) {
                  daysString = daysString + ", " + daysText[value];
                } else {
                  daysString = daysString + ", " + daysText[value];
                }
              });

              timeToRender.push({
                days: daysString,
                open: time.open,
                close: time.close,
              });
            }
          } else {
            timeToRender.push({
              days: daysText[time.days[0]],
              open: time.open,
              close: time.close,
            });
          }
        });

        let closeDays = [];

        if (!allDays.includes(0)) {
          closeDays.push(0);
        }
        if (!allDays.includes(1)) {
          closeDays.push(1);
        }
        if (!allDays.includes(2)) {
          closeDays.push(2);
        }
        if (!allDays.includes(3)) {
          closeDays.push(3);
        }
        if (!allDays.includes(4)) {
          closeDays.push(4);
        }
        if (!allDays.includes(5)) {
          closeDays.push(5);
        }
        if (!allDays.includes(6)) {
          closeDays.push(6);
        }
        if (!allDays.includes(7)) {
          closeDays.push(7);
        }

        closeDays.sort();

        let timeClose = [];

        if (closeDays.length > 0) {
          if (closeDays.length > 1) {
            let daysString;
            closeDays.forEach((value, index) => {
              if (index === 0) {
                daysString = daysText[value];
              } else if (index === value.length - 1) {
                daysString = daysString + ", " + daysText[value];
              } else {
                daysString = daysString + ", " + daysText[value];
              }
            });
            timeClose.push({
              days: daysString,
              text: t("Encerrado"),
            });
          } else {
            timeClose.push({
              days: daysText[closeDays[0]],
              text: t("Encerrado"),
            });
          }
        }

        let renderTimeText = [];
        let renderTimeCLose = [];

        timeToRender.length > 0 &&
          timeToRender.forEach((value, index) => {
            renderTimeText.push(
              <p key={index}>
                <Bold>{value.days}</Bold> - {value.open} {t("às")} {value.close}
              </p>
            );
          });

        timeClose.length > 0 &&
          timeClose.forEach((value, index) => {
            renderTimeCLose.push(
              <p key={index}>
                <Bold>{value.days}</Bold> - {value.text}
              </p>
            );
          });

        return (
          <BannerColContent>
            {renderTimeText}
            {renderTimeCLose}
          </BannerColContent>
        );
      }
    }
    return (
      <p>
        <Bold>{t("Sem horário disponível")}</Bold>
      </p>
    );
  }

  decodeRegion(r) {
    if (r === 1) {
      return "Norte";
    } else if (r === 2) {
      return "Centro";
    } else {
      return "Sul";
    }
  }

  render() {
    const { type, data, t } = this.props;
    return (
      <BannerDetailsContent>
        <BackgroundImage
          style={{ backgroundImage: "url(" + data.banner.path + ")" }}
        >
          <Mask></Mask>
        </BackgroundImage>
        <BannerContent>
          <Container className="bannerSize">
            <ContentAlign>
              {/* RESTAURANTS */}
              {type === "0" && (
                <Restaurants>
                  <ResLogo>
                    <img src={data.restaurantLogo.path} alt={data.name} />
                  </ResLogo>
                  <Title>
                    {t("BEM VINDO AO")} {data.name}
                  </Title>
                  <SubTitle>
                    {data.description == null ? "-" : data.description}
                  </SubTitle>
                  <BannerCols>
                    <BannerCol>
                      <BannerColHeader>
                        {t("Horário de Funcionamento")}:
                      </BannerColHeader>
                      <BannerColContent>
                        {this.renderTime(data.time)}
                      </BannerColContent>
                    </BannerCol>
                    <Margin></Margin>
                    <BannerCol>
                      <BannerColHeader>{t("Contactos")}:</BannerColHeader>
                      <BannerColContent>
                        {data.contact !== '' && (
                          <p>
                            <Bold>{t("Telefone")}</Bold> - {data.contact}
                          </p>
                        )}
                        {data.email !== '' && (
                          <p>
                            <Bold>E-mail</Bold> -{" "}
                            <a href={"mailto:" + data.email} target="_top">
                              {data.email}
                            </a>
                          </p>
                        )}
                        {data.website !== '' && (
                          <p>
                            <Bold>Website</Bold> -{" "}
                            <a href={data.website} target="_blank">
                              {data.website}
                            </a>
                          </p>
                        )}
                        {data.facebook !== '' && (
                          <p>
                            <Bold>Facebook</Bold> -{" "}
                            <a href={data.facebook} target="_blank">
                              {data.facebook}
                            </a>
                          </p>
                        )}
                        {data.instagram !== '' && (
                          <p>
                            <Bold>Instagram</Bold> -{" "}
                            <a href={data.instagram} target="_blank">
                              {data.instagram}
                            </a>
                          </p>
                        )}
                        {data.twitter !== '' && (
                          <p>
                            <Bold>Twitter</Bold> -{" "}
                            <a href={data.twitter} target="_blank">
                              {data.twitter}
                            </a>
                          </p>
                        )}

                      </BannerColContent>
                    </BannerCol>
                  </BannerCols>
                  {data.typology === '3' && (
                    <IconNetwork>
                      <ImageNet>
                        <img src={NetWork} alt={t("type_tasca")} />
                      </ImageNet>
                      <TextNet>{t("type_tasca")}</TextNet>
                    </IconNetwork>
                  )}
                  {data.typology === '4' && (
                    <IconNetwork>
                      <ImageNet>
                        <img src={NetWork} alt={t("type_classico")} />
                      </ImageNet>
                      <TextNet>{t("type_classico")}</TextNet>
                    </IconNetwork>
                  )}
                  {data.typology === '5' && (
                    <IconNetwork>
                      <ImageNet>
                        <img src={NetWork} alt={t("type_fine_dining")} />
                      </ImageNet>
                      <TextNet>{t("type_fine_dining")}</TextNet>
                    </IconNetwork>
                  )}
                </Restaurants>
              )}

              {/* PRODUCTS */}
              {type === "1" && (
                <Restaurants>
                  {data.name !== null && <Title>{data.name}</Title>}
                  {data.description !== null && (
                    <SubTitle>{data.description}</SubTitle>
                  )}
                  {data.qualification !== null && (
                    <BannerCols>
                      <BannerCol>
                        <BannerColHeader>
                          {data.qualification === 1 &&
                            "DOP - Denominação de Origem Protegida"}
                          {data.qualification === 2 &&
                            "ETG - Especialidade Tradicional Garantida"}
                          {data.qualification === 3 &&
                            "IGP - Indicação Geográfica Protegida"}
                        </BannerColHeader>
                      </BannerCol>
                    </BannerCols>
                  )}
                </Restaurants>
              )}

              {/* RECIPES */}
              {type === "2" && (
                <Restaurants>
                  {data.name !== null && <Title>{data.name}</Title>}
                  {data.description !== null && (
                    <SubTitle>{data.description}</SubTitle>
                  )}
                  {/* -----------Subtitulo (vai ser alterado) ------------*/}
                  {
                    <BannerCols>
                      <BannerCol>
                        <BannerColHeader>
                          <RegionTitle>Região: </RegionTitle>
                          <RegionText>
                            {this.decodeRegion(data.region)}
                          </RegionText>
                        </BannerColHeader>
                      </BannerCol>
                    </BannerCols>
                  }
                </Restaurants>
              )}
            </ContentAlign>
          </Container>
        </BannerContent>
      </BannerDetailsContent>
    );
  }
}

const BannerDetailsContent = styled.div`
  width: 100%;
  height: 660px;
  overflow: hidden;
  position: relative;
`;
const BackgroundImage = styled.div`
  position: absolute;
  left: -24px;
  right: -24px;
  bottom: -24px;
  top: -24px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(12px);
`;
const Mask = styled.div`
  width: 100%;
  height: 684px;
  background-color: rgba(0, 0, 0, 0.2);
`;
const BannerContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  color: #fff;
`;
const ContentAlign = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

/* RESTAURANTS */
const Restaurants = styled.div``;
const ResLogo = styled.div`
  width: 80px;
  height: 80px;
  background-color: #fff;
  border-radius: 80px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 80px;
  }
`;
const Title = styled.h1`
  color: #ffffff;
  font-family: Bazar;
  font-size: 48px;
  font-weight: 500;
  line-height: 58px;
  text-transform: uppercase;
  margin-bottom: 20px;
`;
const SubTitle = styled.div`
  max-width: 599px;
  color: #ffffff;
  font-family: "PT Sans";
  font-size: 18px;
  line-height: 22px;
`;
const BannerCols = styled.div`
  display: flex;
  margin-top: 20px;
`;
const BannerCol = styled.div``;
const BannerColHeader = styled.div`
  font-weight: 600;
  font-size: 17px;
`;
const BannerColContent = styled.div`
  font-size: 14px;
  p {
    margin-top: 8px;
    margin-bottom: 8px;

    a {
      color: #fff;
    }
  }
`;
const Bold = styled.span`
  font-weight: 600;
`;
const Margin = styled.div`
  width: 40px;
`;

const IconNetwork = styled.div`
  position: absolute;
  background-color: ${Colors.primary};
  right: 15px;
  top: 100px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 6px;
  padding-right: 20px;
  padding-left: 20px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
`;
const ImageNet = styled.div`
  margin-right: 10px;
  margin-bottom: -2px;
`;
const TextNet = styled.div`
  font-weight: 600;
  font-family: "PT Sans";
  text-transform:uppercase;
`;

/* PRODUCTS */
const RegionText = styled.span`
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
`;
const RegionTitle = styled.span`
  font-weight: 600;
  font-size: 17px;
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/containers/Banner/banner.container.js